import _ from 'lodash';
import { getNested, setNested } from './utils';
import Moment from 'moment';

export const rules = [
  {
    type: 'email',
    regExp: /^[\w.-]+@([\w-]+\.)+com$/i,
  },
  {
    type: 'justLetters',
    regExp: /^([a-zA-Z]\s?)*$/,
  },
  {
    type: 'justNumbers',
    regExp: /^([0-9]\s?)*$/,
  },
  {
    type: 'zipCode',
    regExp: /^([0-9]\s?){5}$/,
  },
];

function getRegExp (type) {
  const item = _.find(rules, { type });
  return item.regExp;
}

export function validateExp ({ type, value }) {
  const regExp = getRegExp(type);
  if (regExp.test(value)) return true;
  return false;
}

export const maxLength = maxValue => (value, previousValue) => {
  if (value.length > maxValue) {
    return previousValue;
  }
  return value;
};

export const isValidDate = (day = '00', month = '00', year) => {
  month = month.length === 1 ? `0${month}` : month;
  day = day.length === 1 ? `0${day}` : day;
  year = year || '';
  const enteredDate = Moment(`${day}-${month}-${year}`, 'DD-MM-YYYY', true);

  if (!enteredDate.isValid()) {
    return { valid: false, reason: 'incomplete' };
  }

  const isEighteenYearsOld = Moment().subtract(18, 'years');
  if (enteredDate.isAfter(isEighteenYearsOld)) {
    return { valid: false, reason: 'invalid' };
  }

  // valid and over 18
  return { valid: true };
};

function validatePhoneNumber (values) {
  const errors = {};
  if (values.areaCode) {
    if (values.areaCode.length > 0 && values.areaCode.length < 3) {
      errors.areaCode = { invalid: true };
    } else if (values.areaCode.length === 0) {
      errors.areaCode = true;
    }
  }
  if (values.firstThreeDigits) {
    if (values.firstThreeDigits.length > 0 && values.firstThreeDigits.length < 3) {
      errors.firstThreeDigits = { invalid: true };
    } else if (values.firstThreeDigits.length === 0) {
      errors.firstThreeDigits = true;
    }
  }
  if (values.lastFourDigits) {
    if (values.lastFourDigits.length > 0 && values.lastFourDigits.length < 4) {
      errors.lastFourDigits = { invalid: true };
    } else if (values.lastFourDigits.length === 0) {
      errors.lastFourDigits = true;
    }
  }
  return errors;
}

// If validation passed the submit is enable

export const validateEnroll = (values, isHCPpharma) => {
  const errors = {};
  const requiredFields = [
    'firstName',
    'lastName',
    'address1',
    'city',
    'state',
    'zip',
    'gender',
    'month',
    'day',
    'year',
    'areaCode',
    'firstThreeDigits',
    'lastFourDigits',
    'hasMarketingOptIn',
    'hasPermissionOptIn',
    'pharmacyInsurance.pbmName',
    'pharmacyInsurance.memberId',
    'pharmacyInsurance.bin',
  ];

  // required for HCP/Pharma
  if (isHCPpharma) {
    requiredFields.push('prescriber.firstName');
    requiredFields.push('prescriber.lastName');
    requiredFields.push('prescriber.npi');
    requiredFields.push('prescriber.practiceName');
  }

  requiredFields.forEach(function (path) {
    const value = getNested(values, path);
    if (!value) {
      setNested(errors, path, true);
    }
  });

  const dobValidation = isValidDate(values.day, values.month, values.year);
  if (!dobValidation.valid) {
    if (dobValidation.reason === 'invalid') {
      errors.day = { invalid: true };
    } else {
      errors.day = true;
    }
  }

  if (values.zip && values.zip.length > 0 && values.zip.length < 5) {
    setNested(errors, 'zip', { invalid: true });
  } else {
    if (values.zip && !getRegExp('zipCode').test(values.zip)) {
      setNested(errors, 'zip', true);
    }
  }

  if (values.prescriber && values.prescriber.zip && values.prescriber.zip.length > 0 && values.prescriber.zip.length < 5) {
    setNested(errors, 'prescriber.zip', { invalid: true });
  }

  if (values.email && !getRegExp('email').test(values.email)) {
    errors.email = true;
  }

  if (values.email !== values.confirmEmail) {
    errors.confirmEmail = true;
  }

  if (values.pharmacyInsurance && values.pharmacyInsurance.bin && values.pharmacyInsurance.bin.length > 0 && values.pharmacyInsurance.bin.length < 6) {
    setNested(errors, 'pharmacyInsurance.bin', { invalid: true });
  }

  if (values.prescriber && values.prescriber.npi && values.prescriber.npi.length > 0 && values.prescriber.npi.length < 10) {
    setNested(errors, 'prescriber.npi', { invalid: true });
  }

  _.extend(errors, validatePhoneNumber(values));

  return errors;
};

export const validateTermsAndConditions = values => {
  const errors = {};
  const requiredFields = [
    'patientMedication',
    'isAge18',
    'isGovermentPaid',
    'isAgree',
    'hasMedicalAcknowledge',
    'termAndCondAccepted',
    'hasMedicare',
    'hasMedicaid',
    'hasAnyOtherGovermentInsurance',
    'isEligible',
  ];
  requiredFields.forEach(function (val) {
    if (val !== 'isEligible' && !values[val]) {
      errors[val] = true;
    }
  });

  if (
    values.hasMedicare === 'Yes' ||
    values.hasMedicaid === 'Yes' ||
    values.isGovermentPaid === 'Yes' ||
    values.isAge18 === 'No' ||
    values.hasMedicalAcknowledge === 'No' ||
    values.isAgree === 'No' ||
    values.hasAnyOtherGovermentInsurance === 'No' ||
    values.termAndCondAccepted === 'No'
  ) {
    errors.isEligible = true;
  }

  return errors;
};

export const validateReplace = values => {
  const errors = {};
  const requiredFields = [
    'month',
    'day',
    'year',
    'areaCode',
    'firstThreeDigits',
    'lastFourDigits',
  ];
  requiredFields.forEach(function (val) {
    if (!values[val]) {
      errors[val] = true;
    }
  });

  if (!isValidDate(values.day, values.month, values.year)) {
    errors.day = true;
  }

  _.extend(errors, validatePhoneNumber(values));
  return errors;
};
